module.exports = __webpack_public_path__ + "static/media-44a61aeedeb16b42d76286b93654faf5.png";